import type { CopyShape } from "@tami/core/intl";

import type { LEGAL_COPY_PT_BR } from "../legal.copy";

export const LEGAL_COPY_ES_ES: CopyShape<typeof LEGAL_COPY_PT_BR> = {
  terms: {
    title: "Términos de Uso",
    description:
      "Los términos que rigen el uso de Tãmi: planes, cobro, renovación, desistimiento, cancelación, cuenta y responsabilidades.",
  },
  privacy: {
    title: "Política de Privacidad",
    description:
      "Cómo Tãmi recoge, usa, comparte y borra tus datos, con qué base legal y cuáles son tus derechos sobre ellos.",
  },
};
